/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {LonerOutroView} from "../../base/LonerOutroView";
import {Loner} from "../../../Loner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {LonerSound} from "../../../sound/LonerSound";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {PinTheWinFeatureObj} from "../../../server/LonerData";

export class LonerPinTheWinOutroView extends LonerOutroView {

    private static BET_MULTIPLIED_TEXT_POSITION:PIXI.Point = new PIXI.Point(360, 430);
    private static FREESPIN_OUTRO_SPINS_PLAYED_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#f0f0f0",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20,
        stroke: "#c35fa0",
        strokeThickness: 6
    };

    private _assetsContainer:PIXI.Container;
    private _flickerTL:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "LonerPinTheWinOutroView";
        this.init();
    }

    protected init() {
        super.init();
        this._outroContainer.addChild(this._countUp);

        this._assetsContainer = new PIXI.Container();
        this._assetsContainer.alpha = 0;
        this._assetsContainer.visible = false;

        this._betMultipliedText = new PIXI.Text("", LonerPinTheWinOutroView.FREESPIN_OUTRO_SPINS_PLAYED_STYLE);
        this._betMultipliedText.position = LonerPinTheWinOutroView.BET_MULTIPLIED_TEXT_POSITION;
        this._betMultipliedText.anchor.set(0.5, 0.5);
        this._assetsContainer.addChild(this._betMultipliedText);

        this._flickerTL = gsap.timeline({repeat : -1});
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._betMultipliedText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.02, 2)}));
        this._flickerTL.add(() => {
            this._betMultipliedText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._betMultipliedText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });

        this.addChild(this._assetsContainer);
    }

    public getCountUp(amount: number, countDuration: number = 1.5, isWinBelowStake: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            gsap.to(this._countUp, {duration: 0.4, alpha: 1})
        });

        if (isWinBelowStake) {
            countDuration = 0.001;
        }

        if (!isWinBelowStake) {
            tl.add(() => {
                Loner.soundPlayer.startPTWCountUp()
            });
        }
        tl.add(() => {
            this._countUp.startFlicker()
        });
        tl.add(this._countUp.getCountAnimation(0, amount, countDuration));
        if (!isWinBelowStake) {
            tl.add(() => Loner.soundPlayer.stopPTWCountUp());
        }
        tl.add(()=>{
            this._assetsContainer.alpha = 0;
            this._assetsContainer.visible = true;
        });
        tl.add([
            gsap.to(this._assetsContainer, {duration : 0.2, alpha : 1})
        ]);
        tl.add(() => {
            Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, true, isWinBelowStake);
        }, "+=0.1");

        return tl;
    }

    public showOutro(callback: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            Loner.pinTheWinMainView.hideCornerMultipliers(0.001);
            Loner.pinTheWinMainView.clearTrail();
            Loner.pinTheWinMainView.setVhsMulti(1);
            Loner.pinTheWinMainView.hideVhsMulti(0.001);
            Loner.pinTheWinMainView.setPinPosAndVisibility(2, 2, false, 0.001);
            Loner.pinTheWinMainView.showHideBg(false, 0.001);
            Loner.pinTheWinMainView.visible = false;
            this._countUp.position.y = this.getCountUpYPos();
            this._clickCallback = callback;
            let data:PinTheWinFeatureObj = Loner.model.pinTheWinFeatureObj;
            let secondMulti:number;
            if (data.destReelId == 0 && data.destSymId == 0){
                secondMulti = data.cornerValue![0];
            }else if (data.destReelId == 4 && data.destSymId == 0){
                secondMulti = data.cornerValue![1];
            }else if (data.destReelId == 0 && data.destSymId == 4){
                secondMulti = data.cornerValue![2];
            }else if (data.destReelId == 4 && data.destSymId == 4){
                secondMulti = data.cornerValue![3];
            }

            this._betMultipliedText.text = SlotGame.apiPlugin.currency.format(Loner.model.gameData.playedBetValue) + " x " + Loner.model.winMultiplier + " x " + secondMulti!;
            this.visible = true;
        });

        tl.add(() => {
                gsap.to(this._outroContainer, {duration: 0.3, alpha: 1});
            }
        );

        return tl;
    }

    public hideOutro(isWinBelowStake: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        Loner.foregroundView.clearAnimationTrack(3);
        tl.add(() => {
            if (!Loner.model.brokeBank) {
                Loner.soundPlayer.playSound(LonerSound.PTW_OUTRO_CONTINUE_BTN);
                Loner.soundPlayer.stopSound(LonerSound.PTW_OUTRO_LOOP);
            }
            Loner.foregroundView.setMode(LonerGameMode.BACK_FROM_PTW);
            Loner.soundPlayer.switchMusic(LonerGameMode.NORMAL);
            Loner.soundPlayer.fadeMusic(0, 1, 0.001);
            Loner.allReelView.visible = true;
            this._assetsContainer.visible = false;
        });
        tl.add(gsap.to(this._outroContainer, {duration: 0.3, alpha: 0}));
        tl.add(gsap.to(this._button, {duration: 0.2, alpha: 0}), "<");
        tl.add(() => {
            this._countUp.alpha = 0;
            this._countUp.stopAt(0);
            this._countUp.stopFlicker();
        });

        return tl;
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    protected getOutroContent(): PIXI.Container {
        return new PIXI.Container();
    }

    protected getOutroContainerPos(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    protected getCountUpYPos(): number {
        return 334;
    }
}